
// 学历管理
export const educationList = [
  {name: '小学', value: 1},
  {name: '初中', value: 2},
  {name: '中专', value: 3},
  {name: '高中', value: 4},
  {name: '大专', value: 5},
  {name: '本科', value: 6},
  {name: '硕士', value: 7},
  {name: '博士', value: 8},
  {name: '博士后', value: 9},
  {name: '其他', value: 0}
]

export const getEducationName = (type) => {
  if (typeof type !== 'number') {
    type = Number(type)
  }
  const result = educationList.find(item => item.value === type)
  return typeof result === 'undefined' ? '-' : result.name
}


// WEBPACK FOOTER //
// ./src/config/education.js